import { useCallback } from "react";
import { usePrefetchedBrandedFaresOffer, useSearchResultOffer } from "../../hooks/useSearchResults.js";
import useBrandedFares from "../../branded-fares/hooks/useBrandedFares.js";
import useTrackFlightsWebUseOfferPos from "../../hooks/useTrackFlightsWebUseOfferPosExp.js";
import { getMarketingTrackingVariable, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { isDeltaAirlinesOffer } from "../../components/elements/FlightCard/utils.js";
export function useFlightDetailsMobileApiUrl(params) {
    const brandedFareOffers = useBrandedFares(params?.id);
    const flightOffer = useSearchResultOffer(params?.id);
    const flightsWebUseOfferPos = useTrackFlightsWebUseOfferPos();
    const prefetchedbrandedFareOffer = usePrefetchedBrandedFaresOffer(params?.id);
    const shouldForwardBaseOfferToken = isFeatureRunningClientSide("FLIGHTS_WEB_FD_FORWARD_BASE_OFFER_TOKEN");
    const isDelta = isFeatureRunningClientSide("FLIGHTS_DELTA_DONT_SKIP_FETCH_BRANDED_FARES") &&
        flightOffer &&
        isDeltaAirlinesOffer(flightOffer);
    const generateApiUrl = useCallback((urlParams, searchParams) => {
        if (flightsWebUseOfferPos.isVariant) {
            const salesCountry = getMarketingTrackingVariable("salesCountry");
            if (salesCountry)
                searchParams.set("salesCountry", salesCountry);
        }
        const hasPrefetchedBrandedFareOffers = !isDelta &&
            flightOffer &&
            !flightOffer.requestableBrandedFares &&
            !prefetchedbrandedFareOffer &&
            brandedFareOffers.brandedFareOffers?.length;
        if (hasPrefetchedBrandedFareOffers || prefetchedbrandedFareOffer) {
            searchParams.set("hasPrefetchedBrandedFareOffers", "true");
        }
        const requestableBrandedFares = flightOffer?.requestableBrandedFares;
        const shouldSkipBrandedFares = flightOffer && !isDelta && !requestableBrandedFares;
        if (shouldSkipBrandedFares)
            searchParams.set("skipBrandedFares", "1");
        const caSource = urlParams.get("ca_source");
        if (caSource)
            searchParams.set("ca_source", caSource);
        const caPrice = urlParams.get("ca_price");
        if (caPrice)
            searchParams.set("ca_price", caPrice);
        const brandedFareIndex = urlParams.get("brandedFareIndex");
        if (brandedFareIndex)
            searchParams.set("brandedFareIndex", brandedFareIndex);
        const baseOfferToken = urlParams.get("baseOfferToken");
        if (shouldForwardBaseOfferToken && baseOfferToken)
            searchParams.set("baseOfferToken", baseOfferToken);
        const source = urlParams.get("source");
        if (source)
            searchParams.set("source", source);
        return `/api/flight/${params?.id}?${searchParams.toString()}`;
    }, [
        params?.id,
        flightOffer,
        brandedFareOffers,
        prefetchedbrandedFareOffer,
        flightsWebUseOfferPos.isVariant,
        isDelta,
        shouldForwardBaseOfferToken
    ]);
    return {
        generateApiUrl
    };
}
